import { render, staticRenderFns } from "./PlanSettingsDocuments.vue?vue&type=template&id=325b89a6"
import script from "./PlanSettingsDocuments.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports